import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SearchView from "../../widgets/SearchView";
import "./../../App.css";
import "./../../Form.css";
import "./../../Grid.css";
import "./../../View.css";
import "./Moderator.css";
import ModeratorSearchForm from './ModeratorSearchForm';
import { ViewContainer } from "./../../View.jsx";
import ViewUtils from '../../ViewUtils';
import withMenuPermission from "../../widgets/withMenuPermission";


const utils = new ViewUtils();

const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: true, label: 'First Name' },
    { id: 'MiddleName', numeric: false, disablePadding: true, label: 'Middle Name' },
    { id: 'Surname', numeric: false, disablePadding: true, label: 'Surname' },
    { id: 'IDNo', numeric: false, disablePadding: true, label: 'ID Number' },
    { id: 'RegistrationNumber', numeric: false, disablePadding: true, label: 'Registration Number' }
];


const searchParameters = [
    { Name: "FirstName", Value: "" },
    { Name: "MiddleName", Value: "" },
    { Name: "Surname", Value: "" },
    { Name: "IDNo", Value: "" },
    { Name: "RegistrationNumber", Value: "" },
    { Name: "ProvinceID", Value: "0" },
    { Name: "ModeratorRegistrationStatusID", Value: "0" }
]

const filterParameters = [
    { dataField: "FirstName", text: "FirstName" },
    { dataField: "MiddleName", text: "MiddleName" },
    { dataField: "Surname", text: "Surname" },
    { dataField: "IDNo", text: "IDNo" },
    { dataField: "RegistrationNumber", text: "RegistrationNumber" }
]

class ModeratorSearch extends Component {

    constructor(props) {
        super(props)

        this.searchParameters = this.searchParameters = !utils.isNull(this.props.programmeId) ?

            [
                { Name: "ID", Value: this.props.programmeId },
                { Name: "FirstName", Value: "" },
                { Name: "MiddleName", Value: "" },
                { Name: "Surname", Value: "" },
                { Name: "IDNo", Value: "" },
                { Name: "RegistrationNumber", Value: "" },
                { Name: "ProvinceID", Value: "0" },
                { Name: "ModeratorRegistrationStatusID", Value: "0" }
            ]
            :

            [
                { Name: "FirstName", Value: "" },
                { Name: "MiddleName", Value: "" },
                { Name: "Surname", Value: "" },
                { Name: "IDNo", Value: "" },
                { Name: "RegistrationNumber", Value: "" },
                { Name: "ProvinceID", Value: "0" },
                { Name: "ModeratorRegistrationStatusID", Value: "0" }
            ]

        if (!utils.isNull(this.props.programmeId)) {
            this.state = {
                model: {
                    FirstName: "",
                    MiddleName: "",
                    Surname: "",
                    IDNo: "",
                    RegistrationNumber: "",
                    ID: this.props.programmeId,
                },
                keyUpSwitch: false,
                selectedModerator: null
            };
        }
        else {
            this.state = {
                model: {
                    FirstName: "",
                    MiddleName: "",
                    Surname: "",
                    IDNo: "",
                    RegistrationNumber: ""
                },
                keyUpSwitch: false,
                selectedModerator: null
            };
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add},
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit},
                        { id: "delete", label: "", tooltip: "Remove Learnership", icon: "DeleteIcon", disabled: true, visible: this.props.menuPermissionItem.Delete}
                    ]
                }
            ]
        };
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedModerator: selection })
        }
        else {
            this.setState({ selectedModerator: null })
        }
    }

    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "add") {
            this.props.history.push({
                pathname: '/addModderatorFlow'
            })
        }
    }

    render() {
        return (
            <ViewContainer title={""}>
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/Moderator/GetSearch"}
                    entityViewPath='/moderator' model={this.state.model}
                    toolbarConfig={this.toolbarConfig} searchParameters={this.searchParameters}
                    filterParameters={filterParameters}
                    title='Moderator'
                    mode={this.props.mode}
                    multiSelect={this.props.multiSelect}
                    onLookupValueChange={this.props.onLookupValueChange} descriptionProp="FirstName" SecondDescriptionProp="Surname"
                    history={this.props.history}
                    buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch} deleteUrl={"api/sims/Moderator/RemoveModerator"} useDeletePost={true}
                    promptTitle={"Remove Moderator"} promptContent={"Are you sure you want to remove this Moderator?"}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                >
                    <ModeratorSearchForm data={this.state.model} onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }} />
                </SearchView>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(ModeratorSearch));

